import { api } from '@/api/api';

const mapData = {
  fromApi(domain) {
    return {
      ...domain,
      editing: false,
      parameter_list: domain.parameter_list.map((value) => ({ value })),
    };
  },
  toApi(domain) {
    return {
      ...domain,
      ...(domain.parameter_list
        ? { parameter_list: domain.parameter_list.map((el) => el.value) }
        : {}),
    };
  },
};

export const domain = {
  namespaced: true,
  state: {
    fetchingList: false,
    list: [],
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setDomains(state, domains) {
      state.list = domains;
    },
    addDomain(state, domain) {
      state.list.push(domain);
    },
  },
  actions: {
    async fetchDomains({ rootState, commit }) {
      if (rootState.company.currentId === -1) {
        return;
      }
      commit('setFetching', true);
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/domains/`
      );
      commit('setDomains', data.map(mapData.fromApi));
      commit('setFetching', false);
    },
    async updateDomain({ rootState, state, commit }, domain) {
      await api.patch(
        `companies/${rootState.company.currentId}/domains/${domain.id}/`,
        mapData.toApi(domain)
      );
      commit(
        'setDomains',
        state.list.map((d) => {
          if (d.id === domain.id) {
            return domain;
          }
          return d;
        })
      );
    },
    async addDomain({ rootState, commit }, domain) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/domains/`,
        mapData.toApi(domain)
      );
      commit('addDomain', mapData.fromApi(data));
    },
  },
};
